import { Activity, ActivityAction, ActivityActions } from "../model";

export function loadAvailableActivities(activities: Activity[]): ActivityAction {
	return {
		type: ActivityActions.LOAD_AVAILABLE_ACTIVITIES,
		payload: activities,
	};
}